/**
 * botCast — Q (then later W) when off CD vs an in-range target (FID-BOT-19).
 *
 * Pure JS — no Three.js, no DOM.
 */

function entityZ(e) {
  if (!e) return 0;
  if (e.z !== undefined) return e.z;
  return e.y !== undefined ? e.y : 0;
}

export function canCastSlot(bot, slot) {
  if (!bot?.cooldowns || typeof bot.cooldowns !== 'object') return false;
  return (Number(bot.cooldowns[slot]) || 0) <= 0;
}

function firstReadyAbilitySlot(bot) {
  if (canCastSlot(bot, 'Q')) return 'Q';
  if (canCastSlot(bot, 'W')) return 'W';
  return null;
}

export function botCombatDecision(bot, target) {
  if (!target) return null;
  const slot = firstReadyAbilitySlot(bot);
  if (slot) {
    return {
      action: 'cast',
      slot,
      targetEntity: target,
      targetX: target.x,
      targetZ: entityZ(target)
    };
  }
  return { action: 'attack', targetEntity: target };
}
